module.exports = __webpack_public_path__ + "static/7-a46e02c953f26e0918ab3e1c149dca4d.jpg";